<div fxFill class="container">
    <div fxLayout="row" fxLayoutAlign="center center" fxFlex>
        <div fxLayout="column" fxLayoutAlign="center center" fxFlex>
            <mat-spinner color="accent"></mat-spinner>
        </div>
    </div>
</div>